import { render, staticRenderFns } from "./ItemBookActive.vue?vue&type=template&id=bd5f65de&scoped=true&"
import script from "./ItemBookActive.vue?vue&type=script&lang=js&"
export * from "./ItemBookActive.vue?vue&type=script&lang=js&"
import style0 from "./ItemBookActive.vue?vue&type=style&index=0&id=bd5f65de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5f65de",
  null
  
)

export default component.exports